import VueClick from 'vue-click'

export default defineNuxtPlugin(app => {
  app.vueApp.use(VueClick)
})
